import React from "react";
import { Form, Input, Button, Select, message, Switch, Modal } from "antd";
import { ProjectService, TechnicainService } from "../../../services";
import { Moment } from "../../../helpers";
import "./style.scss";
import { CheckCircleOutlined, CloseOutlined } from "@ant-design/icons";
const { Option } = Select;

class TechnicianAdd extends React.Component {
  state = {
    homes: [],
    projects: [],
    loadingProject: false,
    loading: false,
    disabledSelectHome: true,
    home: {},
    project: {},
    count: 2,
    items: [
      // {
      //   landsize: 19.60,
      //   rate: 25,
      //   start_date: '2019-12-01',
      //   end_date: '2019-12-31',
      //   day_count: 365,
      //   total: 1,
      // },
    ],
  };
  constructor() {
    super();
  }
  formRef = React.createRef();

  handleSubmit = (values) => {
    this.setState({ loading: true });
    console.log("value", values);
    if (values) {
      TechnicainService.create(values)
        .then((rs) => {
          if (rs) {
            this.setState({ loading: false });
            this.resetForm();
            const res = rs.data["data"];
            message.success(rs.data["message"], 5);
            this.props.onCancel();
            this.props.reload();
          }
        })
        .catch((err) => {
          this.setState({ loading: false });
        });
    }
  };
  componentDidMount() {}
  UNSAFE_componentWillMount() {
    this.setState({
      landSize: 0,
    });
    this.getProjects();
  }
  getProjects = () => {
    this.setState({ loadingProject: true });
    this.setState({ homes: [] });
    ProjectService.all()
      .then((rs) => {
        if (rs) {
          let data = [];
          rs.data["data"].map((item) => {
            let homes = [];
            if (item.homeCustomer) {
              item.homeCustomer.map((home) => {
                homes.push({
                  value: home.id,
                  label:
                    "แปลง " +
                    home.plan_no +
                    (home.home_no ? " (เลขที่ " + home.home_no + ")" : ""),
                });
              });
            }
            data.push({
              value: item.id,
              label: item.name,
              children: homes,
            });
          });
          this.setState({ loadingProject: false });
          this.setState({ projects: data, loading: false });
        }
      })
      .catch((err) => this.setState({ loadingHome: false }));
  };
  getHomeByProjectId = (projectId) => {
    this.setState({ disabledSelectHome: true });
    ProjectService.getHomesByProject(projectId)
      .then((rs) => {
        if (rs) {
          this.setState({ disabledSelectHome: false });
          this.setState({ homes: rs.data["data"], loading: false });
        }
      })
      .catch((err) => this.setState({ loadingHome: false }));
  };

  resetForm() {
    document.getElementById("technicianForm").reset();
    this.formRef.current.resetFields();
  }

  render() {
    const {
      projects,
      homes,
      disabledSelectHome,
      loading,
      home,
      project,
    } = this.state;

    const formLayout = "horizontal";
    const formItemLayout =
      formLayout === "horizontal"
        ? {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 4 },
              md: { span: 4 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 20 },
              md: { span: 20 },
            },
          }
        : null;
    const buttonItemLayout =
      formLayout === "horizontal"
        ? {
            wrapperCol: {
              xs: { span: 24, offset: 0 },
              sm: { span: 20, offset: 4 },
              md: { span: 10, offset: 4 },
            },
          }
        : null;

    const listProjectItems = projects.map((item, index) => (
      <Option key={index} value={item.value}>
        {item.label}
      </Option>
    ));

    return (
      <div id="technician-form-add">
        <Modal
          title="เพิ่มช่าง"
          key="modal-add"
          open={this.props.visible}
          closable
          footer=""
          onCancel={() => this.props.onCancel()}
          bodyStyle={{ padding: "5" }}
          centered
        >
          <Form
            id="technicianForm"
            onFinish={this.handleSubmit}
            ref={this.formRef}
            initialValues={{
              project_id: null,
              fistname: null,
              lastname: null,
              nickname: null,
              active: false,
            }}
          >
            <Form.Item
              label="โครงการ"
              name="project_id"
              {...formItemLayout}
              rules={[{ required: true, message: "เลือกโครงการ" }]}
            >
              <Select
                showSearch
                style={{}}
                placeholder="--เลือกโครงการ--"
                onChange={this.onChangeProject}
                allowClear
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {listProjectItems}
              </Select>
            </Form.Item>
            <Form.Item
              label="ชื่อ"
              name="firstname"
              {...formItemLayout}
              rules={[{ required: true, message: "กรุณากรอกชื่อ" }]}
            >
              <Input type="text" placeholder="ชื่อ" />
            </Form.Item>
            <Form.Item
              label="นามสกุล"
              {...formItemLayout}
              name="lastname"
              rules={[{ required: true, message: "กรุณากรอกนามสกุล" }]}
            >
              <Input type="text" placeholder="นามสกุล" />
            </Form.Item>
            <Form.Item
              label="ชื่อเล่น"
              name="nickname"
              {...formItemLayout}
              rules={[{ required: true, message: "กรุณากรอกชื่อเล่น" }]}
            >
              <Input type="text" placeholder="ชื่อเล่น" />
            </Form.Item>
            <Form.Item
              label="สถานะ"
              {...formItemLayout}
              name="active"
              rules={[
                {
                  required: true,
                  message: "สถานะ!",
                },
              ]}
            >
            <Input type="number" max="1" min="0" placeholder="0=Inactive/1=active"/>
            </Form.Item>
            <Form.Item {...buttonItemLayout}>
              <Button type="primary" htmlType="submit" className="submit">
                บันทึก
              </Button>{" "}
              <Button
                type="light"
                htmlType="reset"
                className="submit"
                onClick={() => this.resetForm()}
              >
                รีเซ็ต
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}
export default TechnicianAdd;
